<div class="action">
  <app-popup-top-line></app-popup-top-line>
  <div class="action-header">
    <div class="title">
      {{ 'commonActions.manageAccessAction.manageAccess' | labelsProvider }}
    </div>
    <img style="cursor: pointer" src="assets/images/common/cancel.svg" (click)="closeWindow()" />
  </div>

  <div class="action-body">
    <div class="loading-users-list" *ngIf="isWaitingForListUpdate">
      <mat-progress-spinner [diameter]="20" class="spinner loading-users-spinner" mode="indeterminate">
      </mat-progress-spinner>
      {{ 'commonActions.manageAccessAction.fetchingPermissionsFromPlatform' | labelsProvider }}
    </div>

    <ul class="users-list">
      <li *ngFor="let user of permissions" [ngSwitch]="user.identityResourceType">
        <div class="user-metadata">
          <div class="user-display-name">
            <div class="user-type-icon">
              <img *ngSwitchCase="'user'" matTooltip="User" src="assets/images/common/user.svg" />
              <img
                *ngSwitchCase="'azureActiveDirectoryGroup'"
                matTooltip="Active Directory User Group"
                src="assets/images/common/users.svg"
              />
              <img *ngSwitchCase="'tenant'" matTooltip="Tenant" src="assets/images/common/globe.svg" />
            </div>
            {{ user.displayName }}
            {{ user.email ? ' • ' + user.email : '' }}
          </div>
          <div class="user-permission">
            {{ user.permissionType | beautifyDisplayString }}
          </div>
        </div>
        <mat-checkbox
          color="primary"
          *ngIf="canRemoveUserAccess(user)"
          [checked]="isUserSelected(user)"
          (change)="toggleUserSelection(user)"
          [disabled]="isChangeAccessDisabled"
        >
        </mat-checkbox>
        <img
          class="info-tooltip"
          *ngIf="!canRemoveUserAccess(user)"
          src="assets/images/common/info.svg"
          height="16px"
          matTooltip="Platform does not allow removing access from owner"
        />
      </li>
    </ul>

    <div class="remove-access-panel">
      <button
        class="btn-remove-selected"
        (click)="removeAccessSelectedUsers()"
        [ngClass]="{
          'confirm-disabled': waitingForRemoveAccessResponse > 0,
          'btn-remove-selected-disabled': selectedUsers.length === 0,
        }"
      >
        <span *ngIf="waitingForRemoveAccessResponse <= 0">
          {{ 'commonActions.manageAccessAction.revokeAccessSelected' | labelsProvider }}
        </span>
        <mat-progress-spinner
          [diameter]="20"
          class="spinner"
          *ngIf="waitingForRemoveAccessResponse > 0"
          mode="indeterminate"
        >
        </mat-progress-spinner>
      </button>
    </div>

    <div class="isolate-resource-panel">
      <div class="isolate-resource-button-container">
        <button
          class="isolate-resource-button"
          (click)="isolateResource($event)"
          [ngClass]="{
            'isolate-resource-button-disabled': isolateResourceButtonDisabled$ | async,
          }"
        >
          <span class="isolate-resource-button-label" *ngIf="!isWaitingForIsolateResourceResponse">
            {{ 'commonActions.manageAccessAction.isolateResourceButtonLabel' | labelsProvider }}
          </span>
          <mat-progress-spinner
            [diameter]="20"
            class="spinner"
            *ngIf="isWaitingForIsolateResourceResponse"
            mode="indeterminate"
          >
          </mat-progress-spinner>
        </button>
        <img
          class="info-tooltip"
          src="assets/images/common/info.svg"
          height="16px"
          matTooltip="{{ isolateAgentButtonTooltip }}"
        />
      </div>
    </div>

    <hr />

    <div
      class="input"
      [ngClass]="{
        'search-invalid': emailControl.invalid && (emailControl.dirty || emailControl.touched),
        'input-disabled': isChangeAccessDisabled,
      }"
    >
      <input
        class="search-input"
        type="text"
        [formControl]="emailControl"
        placeholder="{{ 'commonActions.addOwnerAction.newOwnerEmail' | labelsProvider }}"
        (keyup.enter)="addOwner()"
        [ngClass]="{ disabled: isChangeAccessDisabled }"
      />
    </div>

    <div class="input-invalid-message" *ngIf="emailControl.invalid && (emailControl.dirty || emailControl.touched)">
      {{ 'formErrors.emailFormFieldMsg' | labelsProvider }}
    </div>

    <div class="add-access-panel">
      <span
        class="btn-add-owner"
        (click)="addOwner($event)"
        [ngClass]="{
          'btn-add-owner-disabled': emailControl.invalid || waitingForAddOwnerResponse || isChangeAccessDisabled,
        }"
      >
        <span *ngIf="!waitingForAddOwnerResponse">{{ 'commonActions.addOwner' | labelsProvider }}</span>
        <mat-progress-spinner [diameter]="20" class="spinner" *ngIf="waitingForAddOwnerResponse" mode="indeterminate">
        </mat-progress-spinner>
      </span>

      <span class="btn-open-platform" (click)="openPlatformNewTab()">
        {{ 'commonActions.manageAccessAction.openPlatform' | labelsProvider }}
      </span>
    </div>

    <div class="disclaimer">
      {{ 'commonActions.manageAccessAction.disclaimer' | labelsProvider }}
    </div>
    <div class="disclaimer">
      {{ changeAccessTooltip }}
    </div>
  </div>
</div>
